module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('transition-group', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    key: "editPlanoName",
    staticClass: "modal-mask",
    attrs: {
      "id": "editPlanoName"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('div', {
    staticClass: "modal-wrapper _modalWrapper_"
  }, [_c('div', {
    staticClass: "modal-container flexContainer"
  }, [_c('div', {
    staticClass: "modalBody",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "_container_ rel"
  }, [_c('img', {
    staticClass: "cross fright abs pointer",
    attrs: {
      "src": require("../../../assets/croix.png"),
      "width": "20",
      "height": "20",
      "alt": ""
    },
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "fd-r fw-w m-jc-sb"
  }, [_c('div', {
    staticClass: "flexContainer fd-c ai-c jc-fs"
  }, [_c('div', {
    staticClass: "flexContainer fd-c"
  }, [_c('label', {
    staticClass: "full ff-medium fleft labelName"
  }, [_vm._v(_vm._s(_vm.$t("plano.enter_new_name")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "full planoName mt10",
    attrs: {
      "name": "",
      "placeholder": _vm.$t('plano.name_placeholder')
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('p', {
    staticClass: "ff-light flexContainer fd-r jc-c"
  }, [_c('button', {
    staticClass: "btn_validate pointer",
    on: {
      "click": function($event) {
        _vm.save();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("plano.btn_validate")))])])])])])])])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1cec3e9b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/plano/menu/EditNameModal.vue
// module id = 3057
// module chunks = 0